module.exports = __webpack_public_path__ + "img/step-arrow-last.bf5a1b35.png";